import { pinpointLogic } from './pinpoint.logic';

import { PinpointHostView, PinpointProjectorView, PinpointStudentView } from './PinpointViews';

import type { ActivityPlugin } from '../../core/types/activity.types';

import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';



export const pinpointPlugin: ActivityPlugin<'point'> = {

  ...pinpointLogic,

  displayName: GAME_MODE_CATALOG.point.displayName,

  icon: GAME_MODE_CATALOG.point.icon,

  HostView: PinpointHostView,

  StudentView: PinpointStudentView,

  ProjectorView: PinpointProjectorView,

};



export { demoPinpointPayload } from './pinpoint.logic';

